import React from 'react';
import PropTypes from 'prop-types';
import CloseButton from './CloseButton';

const ModalContent = props => {
  const { onClose, onIgnore, children, displayCloseButton } = props;

  return (
    <div className="pxl-modal__content" onClick={onIgnore}>
      <CloseButton display={displayCloseButton} onClick={onClose} />
      {children}
    </div>
  );
};

ModalContent.propTypes = {
  displayCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
  onIgnore: PropTypes.func
};

export default ModalContent;
